import React, { useState, useEffect, useRef } from 'react';
import './locale-switcher.css';
import { useLocaleSwitcher } from '../../hooks';

export interface LocaleOption {
  label: string;
  value: string ;
}

interface LocaleSwitcherProps {
  value?: string ;
  onChange?: (option: LocaleOption) => void;
  placeholder?: string;
  className?: string;
}

const LocaleSwitcher: React.FC<LocaleSwitcherProps> = ({
  value,
  placeholder,
  className = '',
}) => {

  const { selectedOption, localeOptions, handleOnClick } = useLocaleSwitcher();

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (option: { label: string, value: string }) => {
    setIsOpen(false);
    handleOnClick(option);
  };

  return (
    <div className={`dropdown ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className="dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        {selectedOption ? selectedOption.label : placeholder}
      </button>

      {isOpen && (
        <div className="dropdown-content" role="listbox">
          {localeOptions.map((option) => (
            <button
              key={option.value}
              className="dropdown-item"
              onClick={() => handleSelect(option)}
              role="option"
              aria-selected={option.value === value}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocaleSwitcher; 